import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import NewAvatarHeader from '../NewAvatarHeader';

const AppAccountLayout = ({
  title,
  subtitle,
  backHref = '/app',
  backLabel,
  userData,
  t,
  children,
}) => (
  <div style={{ background: '#111', minHeight: '100vh', color: '#fff' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 20px',
        borderBottom: '1px solid #333',
      }}
    >
      <Link
        to={backHref}
        style={{
          color: '#fff',
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: 600,
        }}
      >
        <ArrowLeft size={18} />
        {backLabel}
      </Link>
      <NewAvatarHeader userData={userData} t={t} darkMode />
    </div>

    <div style={{ maxWidth: '960px', margin: '0 auto', padding: '32px 20px 64px' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '8px' }}>{title}</h1>
      {subtitle ? (
        <p style={{ color: '#aaa', marginBottom: '32px', maxWidth: '720px' }}>{subtitle}</p>
      ) : null}
      {children}
    </div>
  </div>
);

export default AppAccountLayout;
